import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Models } from '@ibexfusion/models';

@Component({
  selector: 'app-global-variables-edit',
  templateUrl: './global-variables-edit.component.html',
  styleUrl: './global-variables-edit.component.scss',
  standalone: false
})
export class GlobalVariablesEditComponent implements OnInit {
  variable: Models.GlobalVariable;

  constructor(public dialogRef: MatDialogRef<GlobalVariablesEditComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {

  }

  ngOnInit() {
    this.variable = new Models.GlobalVariable();
    if (!!this.data) {
      this.variable.populateFromJSON(this.data);
    }
  }

  getDisplayType(varType: string) {
    switch (varType) {
      case 'string':
        return 'STRING';
      case 'number':
        return 'NUMBER';
      case 'date':
        return 'DATE';
      case 'dayMonth':
        return 'DATE';
    }
  }

  save() {
    this.dialogRef.close(this.variable);
  }
}
